import {
  SET_CATEGORY_SALES_LOADING,
  GET_CATEGORY_SALES_SUCCESS,
  GET_CATEGORY_SALES_ERROR,
} from '../actions/types';

const initialState = {
  isLoading: false,
  categorySales: [],
  pagination: {
    currentPage: 1,
    totalPages: 1,
    totalRecords: 0,
    limit: 10,
    hasNextPage: false,
    hasPrevPage: false,
    nextPage: null,
    prevPage: null,
  },
  error: null,
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case SET_CATEGORY_SALES_LOADING:
      return {
        ...state,
        isLoading: payload,
      };

    case GET_CATEGORY_SALES_SUCCESS:
      return {
        ...state,
        categorySales: payload.data,
        pagination: payload.pagination,
        isLoading: false,
        error: null,
      };

    case GET_CATEGORY_SALES_ERROR:
      return {
        ...state,
        isLoading: false,
        error: payload,
      };

    default:
      return state;
  }
}


